import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { TextField, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import { useAddRegister } from "./hooks/useAddRegister";

export type AddFraudProps = {
    onConfirm: (data: any) => void;
    onClose: () => void;
    open: boolean;
    title: string;
    operation: any;
    channel: any;
    type: any;
    error: boolean;
    tabActive: string;
    update?: any;
} & DefaultComponentProps;

export const AddFraudDialog = ({ onConfirm, onClose, open, title, operation, channel, type, error, tabActive, update }: AddFraudProps) => {
    const { form, onHandleChange, isValidForm } = useAddRegister(open, error, tabActive, update)

    return (
        <Dialog onClose={onClose} open={open}>
	        <DialogTitle>
				<Typography variant="h2">{title}</Typography>
			</DialogTitle>
			<DialogContent>
                <FlexGrid container direction="column" alignItems='flex-start' spacing={2}>
                    <FlexGrid container spacing={2} fullWidth>
                        <TextField value={form.entity_uuid} onInput={onHandleChange.bind(this, "entity_uuid")} label="Customer UUID" color="secondary" fullWidth/>
                    </FlexGrid>
                    <FlexGrid container spacing={2} fullWidth>
                        <FormControl color="secondary" fullWidth>
                            <InputLabel>Canal</InputLabel>
                            <Select value={form.channel || '-1'} onChange={onHandleChange.bind(this, "channel")} label="Canal" color="secondary" MenuProps={{style: {zIndex: 35001}}} >
                                <MenuItem value={-1} disabled>Canal</MenuItem>
                                {channel.map((item) => (
                                    <MenuItem key={`channel-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl color="secondary" fullWidth>
                            <InputLabel>Operación</InputLabel>
                            <Select value={form.operation || '-1'} onChange={onHandleChange.bind(this, "operation")} label="Operación" color="secondary" MenuProps={{style: {zIndex: 35001}}} >
                                <MenuItem value={-1} disabled>Operación</MenuItem>
                                {operation.map((item) => (
                                    <MenuItem key={`operation-${item.key}`} value={item.value}>{item.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </FlexGrid>
                    {tabActive !== 'accumulator' &&
                        <FlexGrid container spacing={2} fullWidth>
                            <FormControl color="secondary" fullWidth>
                                <InputLabel>Tipo</InputLabel>
                                <Select disabled value={form['type'] || '-1'} onChange={onHandleChange.bind(this, "type")} label="Tipo" color="secondary" MenuProps={{style: {zIndex: 35001}}} >
                                    <MenuItem value={"-1"} disabled>Tipo</MenuItem>
                                    {type.map((item, index) => {
                                        return <MenuItem key={`type-${index}`} value={item.name}>{item.title}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                            {form['type'] === 'blacklist' &&
                                <TextField value={form['expired_date']?.slice(0, 16) || new Date().toJSON().slice(0, 16)} onInput={onHandleChange.bind(this, "expired_date")} InputLabelProps={{ shrink: true }} type={"datetime-local"} style={{ cursor: "pointer" }} color="secondary" label="Fecha expiración" fullWidth />
                            }
                        </FlexGrid>
                    }
                </FlexGrid>
			</DialogContent>
			<DialogActions>
				<FlexGrid container fullHeight fullWidth justify='space-between' alignItems='flex-end' style={{ marginTop: '20px' }}>
					<FlexGrid item>
						<Button onClick={onClose} buttonType='secondary' size='normal'>
							Cancelar
						</Button>
					</FlexGrid>
					<FlexGrid item>
						<Button onClick={() => onConfirm(form)} disabled={isValidForm} size='normal'>
							Aceptar
						</Button>
					</FlexGrid>
				</FlexGrid>
			</DialogActions>
        </Dialog>
    )
}